import React, { ReactElement } from "react";
import TopSalesCategoriesWiseReportList from "../../components/Reports/SalesProdutCategoriesWiseReport";
import MainLayout from "../../components/Layouts";

const TopSalesCategoryWiseReportPage = (): ReactElement => {
  return (
    <MainLayout>
      <TopSalesCategoriesWiseReportList />
    </MainLayout>
  );
}; 

export default TopSalesCategoryWiseReportPage;
